import { ReactNode } from 'react';
import { Header } from '~components/Header';
import { Sidebar } from '~components/Sidebar';
import { SidebarProvider, useSidebar } from '~components/Sidebar/Sidebar.context';
import { CommandPalette } from '~components/CommandPalette';
import { ShellContainer, MainWrapper, ContentArea, CollapseToggleButton } from './styles';

interface BreadcrumbItem {
  label: string;
  path?: string;
}

interface AppShellProps {
  children: ReactNode;
  breadcrumb?: BreadcrumbItem[];
  route?: string[];
  minimal?: boolean;
}

const ChevronLeftIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
    <path d="M15 18l-6-6 6-6" />
  </svg>
);

const ChevronRightIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
    <path d="M9 18l6-6-6-6" />
  </svg>
);

function AppShellContent({ children, breadcrumb, route, minimal = false }: AppShellProps) {
  const { isCollapsed, toggleCollapse } = useSidebar();

  return (
    <ShellContainer>
      <Header breadcrumb={breadcrumb} route={route} minimal={minimal} />
      <MainWrapper>
        <Sidebar />
        <CollapseToggleButton
          $collapsed={isCollapsed}
          onClick={toggleCollapse}
          aria-label={isCollapsed ? 'Expandir menu' : 'Recolher menu'}
          title={isCollapsed ? 'Expandir menu' : 'Recolher menu'}
        >
          {isCollapsed ? <ChevronRightIcon /> : <ChevronLeftIcon />}
        </CollapseToggleButton>
        <ContentArea>
          {children}
        </ContentArea>
      </MainWrapper>
      <CommandPalette />
    </ShellContainer>
  );
}

export function AppShell(props: AppShellProps) {
  return (
    <SidebarProvider>
      <AppShellContent {...props} />
    </SidebarProvider>
  );
}
